/**
 * coloriAgenda.js — la tavolozza del colore della colonna in agenda.
 *
 * Un insieme chiuso e distinguibile, invece di un selettore libero che
 * produrrebbe tinte slavate o due medici quasi uguali. Sono valori di DATO
 * (finiscono in agende.colore), non colori dell'interfaccia: per questo
 * stanno qui e non fra i token del tema.
 *
 * Una copia sola dal 6/10/2026: la usano la scheda del medico e la
 * «Modifica» dell'agenda negli Orari, che scrivono lo stesso campo. Prima
 * stava dentro MedicoForm.jsx.
 */
export const COLORI_AGENDA = [
    '#e53935', '#d81b60', '#8e24aa', '#5e35b1', '#3949ab', '#1e88e5',
    '#00897b', '#43a047', '#c0ca33', '#fdd835', '#fb8c00', '#6d4c41',
];
